import { DELETE, GET, POST, PUT } from '../request'

export const getCuadernilloList = () => GET('/api/profes/material/cuadernillo')
export const createCuadernillo = ({ nombre, archivo, asignaturas }) => {
  const formData = new FormData()
  formData.append('nombre', nombre)
  formData.append('documento', archivo, archivo.filename)
  formData.append('asignaturas[]', asignaturas)
  return PUT('/api/profes/material/cuadernillo/nuevo', {}, formData, true)
}
export const updateCuadernillo = ({ cuadernillo, nombre, asignaturas }) =>
  PUT('/api/profes/material/cuadernillo', {
    cuadernillo,
    nombre,
    'asignaturas[]': asignaturas
  })
export const deleteCuadernillo = cuadernillo =>
  DELETE('/api/profes/material/cuadernillo', { cuadernillo })

export const getGuionList = () => GET('/api/profes/material/guion')
export const createGuion = ({ nombre, archivo, asignaturas }) => {
  const formData = new FormData()
  formData.append('nombre', nombre)
  formData.append('documento', archivo, archivo.filename)
  formData.append('asignaturas[]', asignaturas)
  return PUT('/api/profes/material/guion/nuevo', {}, formData, true)
}
export const updateGuion = ({ guion, nombre, asignaturas }) =>
  PUT('/api/profes/material/guion', {
    guion,
    nombre,
    'asignaturas[]': asignaturas
  })
export const deleteGuion = guion =>
  DELETE('/api/profes/material/guion', { guion })

export const getTemarioList = () => GET('/api/profes/material/temario')
export const createTemario = ({ nombre, archivo, asignaturas, tipo }) => {
  const formData = new FormData()
  formData.append('nombre', nombre)
  formData.append('documento', archivo, archivo.filename)
  formData.append('asignaturas[]', asignaturas)
  if (tipo) formData.append('tipo', tipo)
  return PUT('/api/profes/material/temario/nuevo', {}, formData, true)
}
export const updateTemario = ({ temario, nombre, asignaturas, tipo }) =>
  PUT('/api/profes/material/temario', {
    temario,
    nombre,
    'asignaturas[]': asignaturas,
    tipo
  })
export const deleteTemario = temario =>
  DELETE('/api/profes/material/temario', { temario })

export const getExamenList = () => GET('/api/profes/material/examen')
export const createExamen = ({ nombre, tipo, archivo, asignaturas }) => {
  const formData = new FormData()
  formData.append('nombre', nombre)
  formData.append('tipo', tipo)
  formData.append('documento', archivo, archivo.filename)
  formData.append('asignaturas[]', asignaturas)
  return PUT('/api/profes/material/examen/nuevo', {}, formData, true)
}
export const updateExamen = ({ examen, nombre, tipo, asignaturas }) =>
  PUT('/api/profes/material/examen', {
    examen,
    nombre,
    tipo,
    'asignaturas[]': asignaturas
  })
export const deleteExamen = examen =>
  DELETE('/api/profes/material/examen', { examen })

export const getVideoList = () => GET('/api/profes/material/video')
export const createVideo = ({ nombre, url, duracion, asignaturas }) =>
  POST('/api/profes/material/video', {}, { nombre, url, duracion, asignaturas })
export const updateVideo = ({ video, nombre, url, duracion, asignaturas }) =>
  PUT('/api/profes/material/video', {
    video,
    nombre,
    url,
    duracion,
    'asignaturas[]': asignaturas
  })
export const deleteVideo = video =>
  DELETE('/api/profes/material/video', { video })
